import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Image01 from "../../images/solution/startup/account.png";
import {LazyLoadImage} from "react-lazy-load-image-component";

const Startupaccount = () => {
  return (
    <div className="startup_account p-100" style={{background: '#FCFCFC'}}>
 <Container>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
                       <h2>Apps Account for <span>Over 80%</span> of Mobile Time</h2>
                    </Col>
                    <LazyLoadImage
                                        src={Image01}
                                        effect="blur" alt="Image01" className="img-fluid"
                                    />
                </Row>
            </Container>
    </div>
  )
}

export default Startupaccount